function normalizeAthlete(userSession) {
  const user = userSession?.user || userSession || {};
  const name = user.name || user.fullname || user.username || 'Athlete';
  const stravaId = user.strava_id || user.stravaId || user.provider_id || user.id || '';

  return {
    name,
    initials: initialsForName(name),
    email: user.email || '',
    avatar: user.avatar || user.picture || '',
    location: user.location || user.city || 'Việt Nam',
    joinedAt: user.createdAt || user.created_at || user.registered_at || '',
    stravaId,
  };
}

function initialsForName(name) {
  return String(name || 'Athlete')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('') || 'A';
}

function activityStartedAt(activity) {
  return activity?.startDate || activity?.start_date || activity?.start_date_local || '';
}

function distanceFromActivities(activities) {
  return (activities || []).reduce((total, activity) => total + Number(activity?.distance || 0), 0);
}

function uniqueActivityDays(activities) {
  return new Set(
    (activities || [])
      .map(activityStartedAt)
      .filter(Boolean)
      .map((date) => new Date(date).toISOString().slice(0, 10))
  ).size;
}

function latestActivityDate(activities) {
  return (activities || [])
    .map(activityStartedAt)
    .filter(Boolean)
    .sort((a, b) => new Date(b) - new Date(a))[0] || '';
}

function daysBetweenInclusive(startDate, now) {
  if (!startDate) return 1;

  const start = new Date(startDate);
  if (Number.isNaN(start.getTime())) return 1;

  const today = new Date(now || Date.now());
  const startUtc = Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate());
  const todayUtc = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());
  const diff = Math.floor((todayUtc - startUtc) / 86400000) + 1;

  return Math.max(diff, 1);
}

export function buildProfileSummary(userSession, activityResult = {}, now = new Date()) {
  const athlete = normalizeAthlete(userSession);
  const activities = activityResult?.data || [];
  const summaryDistance = Number(activityResult?.summary?.distance || 0);
  const totalDistance = summaryDistance > 0 ? summaryDistance : distanceFromActivities(activities);

  return {
    athlete,
    strava: {
      connected: Boolean(athlete.stravaId),
      id: athlete.stravaId,
    },
    stats: {
      totalKm: Math.round((totalDistance / 1000) * 100) / 100,
      activityCount: activities.length,
      activeDays: uniqueActivityDays(activities),
      daysJoined: daysBetweenInclusive(athlete.joinedAt, now),
      lastActivityDate: latestActivityDate(activities),
    },
  };
}
